// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"181":"4084b03f","312":"404f1b7c","341":"7152b6b2","444":"ef8bfb35","667":"e70e89dd","682":"4918c16f","758":"a31ad57c","916":"d04cd702","932":"06e989d3"}[chunkId] + ".chunk.css";
};